import { LoanRolloverSplitParams } from 'app/models/loan-rollover-split-params'
import { LoanRolloverSplitState } from './reducer'

export const getLoanRolloverSplits = (state: {
  loanRolloverSplits: { loanRolloverSplits: LoanRolloverSplitParams[] }
}) => state.loanRolloverSplits.loanRolloverSplits

export const getApprovedLoanRolloverSplits = (state: {
  loanRolloverSplits: { approvedLoanRolloverSplits: LoanRolloverSplitParams[] }
}) => state.loanRolloverSplits.approvedLoanRolloverSplits

export const getLoanRolloverSplitsLoader = (state: {
  loanRolloverSplits: LoanRolloverSplitState
}) => state.loanRolloverSplits.isLoading
